/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_ButtonInputs */

const en_login_button = /** @type {(inputs: Login_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in with passkey`)
};

const de_login_button = /** @type {(inputs: Login_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit Passkey anmelden`)
};

/**
* | output |
* | --- |
* | "Sign in with passkey" |
*
* @param {Login_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const login_button = /** @type {((inputs?: Login_ButtonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_ButtonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_login_button(inputs)
	return en_login_button(inputs)
});